import { useState, useEffect } from 'react';
import { IFileResponse } from '../../../../../model/scp/base/response/file-response';
import { IFileAddRequest } from '../../../../../model/scp/base/request/file-add-request';
import { ITableResponse } from '../../../../../model/scp/purchase/response/tables-response';
import BaseAppService from '../../../../../application/platform/scp/base/base-app-service';
import IrpAppService from '../../../../../application/platform/scp/irp/irp-app-service';
import { useBaseLayout } from '../../../../../components/context/use-base-layout';

export const useIrpFileController = (irpId?: string) => {
    const { showDialog, showMessage, showLoading } = useBaseLayout();
    const [fileIrpRequest, setFileIrpRequest] = useState<IFileAddRequest>({ id: irpId } as IFileAddRequest);
    const [irpFiles, setIrpFiles] = useState<IFileResponse[]>([]);
    const [loadMoreData, setLoadMoreData] = useState(false);
    const [error, setError] = useState(false);
    const [typeDocument, setTypeDocument] = useState<ITableResponse[]>([]);

    useEffect(() => {
        loadTypeDocuments();
    }, []);

    useEffect(() => {
        loadData();
    }, [irpId]);

    const loadTypeDocuments = async () => {
        try {
            const documentTypes = await BaseAppService.listTypeDocument(6);
            setTypeDocument(documentTypes);
        } catch (error) {
            showMessage({
                open: true,
                message: 'Não foi possível carregar os tipos de documento',
                detail: (error as any).details || (error as Error).message,
                type: 'error'
            });
        }
    };

    const loadData = async () => {
        if (irpId !== undefined) {
            try {
                setLoadMoreData(true);
                const files = await IrpAppService.listIrpFiles({ id: Number(irpId), page: 1, pageSize: 200 });
                setIrpFiles(files);
                setLoadMoreData(false);
            } catch (error) {
                showMessage({
                    open: true,
                    message: 'Não foi possível carregar os arquivos',
                    detail: (error as any).details || (error as Error).message,
                    type: 'error'
                });
                setLoadMoreData(false);
            }
        }
    };

    const handleOnChange = (e: any) => {
        let title = fileIrpRequest?.title;
        let documentTypeId = fileIrpRequest?.documentTypeId;

        if (e !== undefined) {
            if (e.target.name === "input-title-atachment") {
                title = e.target.value;
            } else if (e.target.name === "select-document-type-atachment") {
                documentTypeId = e.target.value;
            }
        }

        setFileIrpRequest(prevState => {
            return { ...prevState, title, documentTypeId };
        });
    };

    const validFields = (): boolean => {
        let isValid = true;

        if (fileIrpRequest.documentTypeId === undefined) {
            isValid = false;
        }
        if (fileIrpRequest.document !== undefined && fileIrpRequest.document === null) {
            isValid = false;
        }
        if (fileIrpRequest.title !== undefined && fileIrpRequest.title.length === 0) {
            isValid = false;
        }

        setError(!isValid);
        return isValid;
    };

    const saveFile = async () => {
        if (validFields()) {
            try {
                showLoading({ open: true });
                await IrpAppService.addFileIrp(fileIrpRequest);
                showMessage({ open: true, message: "Documento adicionado com sucesso!", type: "success" });
                setFileIrpRequest({ id: irpId } as IFileAddRequest);
                showLoading({ open: false });
                await loadData();
            } catch (error) {
                showLoading({ open: false });
                showMessage({
                    open: true,
                    message: 'Não foi possível adicionar o arquivo',
                    detail: (error as any).details || (error as Error).message,
                    type: 'error'
                });
            }
        } else {
            showMessage({ open: true, message: "Preencha todos os campos obrigatórios!", type: "error" });
        }
    };

    const deleteFile = async (sequence: number, justification: string) => {
        if (justification !== undefined && justification.length > 0) {
            if (irpId !== undefined) {
                try {
                    showLoading({ open: true });
                    await IrpAppService.deleteFileIrp(justification, Number(irpId), sequence);
                    await loadData();
                    showLoading({ open: false });
                    showMessage({ message: 'Anexo excluído com sucesso', type: 'success', open: true });
                } catch (error) {
                    showLoading({ open: false });
                    showMessage({
                        open: true,
                        message: 'Não foi possível excluir o arquivo',
                        detail: (error as any).details || (error as Error).message,
                        type: 'error'
                    });
                }
            }
        } else {
            showMessage({ message: 'Informe a justificativa para excluir o anexo', type: 'warning', open: true });
        }
    };

    const setFileUpload = (file: File) => {
        setFileIrpRequest({ ...fileIrpRequest, document: file });
    };

    return {
        // State
        fileIrpRequest,
        irpFiles,
        loadMoreData,
        error,
        typeDocument,

        // Methods
        handleOnChange,
        saveFile,
        deleteFile,
        setFileUpload,
        showDialog,
        showLoading,
        showMessage
    };
};
